import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { togglePriceDisplayQuantity } from '../Actions/ProductsView.action';
import { translate } from '../Services/translation';

const PriceDisplayQuantityToggle = (props) => {
  const { className, onToggle } = props;
  const { quantity: priceDisplayQuantity } = useSelector(
    (state) => state.priceDisplayQuantity
  );
  const wheelBuilderState = useSelector(
    (state) => state.wheelBuilder
  );
  const dispatch = useDispatch();
  const [abortController, setAbortController] = useState();

  const onClick = useCallback(() => {
    var queryString = '';

    if(wheelBuilderState){
      if(wheelBuilderState.currentStep == 2){
        var queryString = wheelBuilderState && wheelBuilderState.selectedCarModelVariantSystemId ? `variantId=${wheelBuilderState.selectedCarModelVariantSystemId + ''}&step=${wheelBuilderState.currentStep}` : '';
      }
      if(wheelBuilderState.currentStep == 3){
        var queryString = wheelBuilderState && `variantId=${wheelBuilderState.selectedCarModelVariantSystemId + ''}&step=${wheelBuilderState.currentStep}&rimArticleNumber=${wheelBuilderState.selectedRim?.id}`;
      }
    }
    dispatch(togglePriceDisplayQuantity(null, queryString, abortController)).then(onToggle);
  }, [dispatch, abortController, onToggle]);

  const showingPricesForOne =
    !priceDisplayQuantity || priceDisplayQuantity == 1;

  useEffect(() => setAbortController(new AbortController()), []);

  return (
    <div
      className={`
        ${
          showingPricesForOne
            ? 'product__price-display-quantity'
            : 'product__price-display-quantity product__price-display-quantity--active'
        }
        ${className ?? ''}
      `}
      onClick={onClick}
    >
      <img
        src={
          showingPricesForOne
            ? '/ui/images/1-tire-icon.svg'
            : '/ui/images/4-tires-icon.svg'
        }
      />
      {showingPricesForOne ? (
        translate('category.showing-price-for-1')
      ) : (
        <>
          {translate('category.showing-price-for')} {priceDisplayQuantity}
        </>
      )}
    </div>
  );
};

export default PriceDisplayQuantityToggle;
